import './CustomTooltip.css';

function CustomTooltip() {}

CustomTooltip.prototype.init = function(params) {
  const type = params.type || 'primary';
  const title = params.title;
  const data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
  const eGui = (this.eGui = document.createElement('div'));
  const { colDef } = params;

  eGui.classList.add('custom-tooltip');
  this.eGui.innerHTML = `<div class="panel panel-${type}">
    <div class="panel-heading">
      <h3 class="panel-title">
        ${title ?? colDef.headerName}
      </h3>
    </div>
    <div class="panel-body">
      <h4>
        ${data[colDef.field]}
      </h4>
    </div>
  </div>`;
};

CustomTooltip.prototype.getGui = function() {
  return this.eGui;
};

export default CustomTooltip;
